import {Col, Row} from "antd";
import React, {useEffect} from "react";
import {useCourierWalletInvoiceSubTab} from "./useCourierWalletInvoiceSubTab";
import {CourierWalletInvoicesList} from "./courierWalletInvoicesList/CourierWalletInvoicesList";
import {CourierWalletInvoiceDetail} from "./courierWalletInvoiceDetail/CourierWalletInvoiceDetail";
import moment from "moment";

export const CourierWalletInvoiceSubTab = ({
    courier,
    canRender = false,
    walletStartDate,
    walletStartDateRecall
}) => {
    const {
        paymentInvoicesResultLoading,
        paymentInvoices,
        selectedPaymentInvoice,
        selectedDateRange,
        handleDateRangeChange,
        handlePaymentInvoiceSelect
    } = useCourierWalletInvoiceSubTab({courier, canRender});

    useEffect(() => {
        if (canRender && walletStartDateRecall) {
            handleDateRangeChange([moment(walletStartDate), selectedDateRange?.[1]]);
        }
    }, [walletStartDateRecall]);
    return (
        <Row gutter={[16, 16]}>
            <Col xs={24} sm={24} md={24} lg={24} xl={8}>
                <CourierWalletInvoicesList
                    paymentInvoices={paymentInvoices}
                    onItemSelect={handlePaymentInvoiceSelect}
                    selectedItem={selectedPaymentInvoice}
                    selectedDateRange={selectedDateRange}
                    onDateRangeChange={handleDateRangeChange}
                    loading={paymentInvoicesResultLoading}
                />
            </Col>
            <Col xs={24} sm={24} md={24} lg={24} xl={16}>
                {selectedPaymentInvoice && (
                    <CourierWalletInvoiceDetail
                        paymentInvoice={selectedPaymentInvoice}
                        loading={paymentInvoicesResultLoading}
                    />
                )}
            </Col>
        </Row>
    );
};
